__turbopack_context__.v({
  "container": "ShowcaseGrid-module-scss-module__q_5A9G__container",
  "grid": "ShowcaseGrid-module-scss-module__q_5A9G__grid",
  "grid-carousel": "ShowcaseGrid-module-scss-module__q_5A9G__grid-carousel",
  "scroll-area": "ShowcaseGrid-module-scss-module__q_5A9G__scroll-area",
});
